var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9463 7.92015C15.9463 7.92015 19.5023 2.618 25.1439 5.21709C25.1439 5.21709 33.9997 8.75186 24.8704 20.9849C24.8704 20.9849 19.4339 27.0841 16.0831 27.5C12.7323 27.1188 7.22736 21.0542 7.22736 21.0542C-2.03865 8.92513 6.81706 5.2864 6.81706 5.2864C12.3903 2.618 15.9805 7.92015 15.9805 7.92015H15.9463Z",
    fill: "url(#paint0_radial_7508_164794)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7508_164794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0946 -6.2656) rotate(-0.255371) scale(45.4566 42.8328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF81B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3171,
    stopColor: "#FE77AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6625,
    stopColor: "#F61441"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiHeart);
export default __webpack_public_path__ + "static/media/emoji_heart.eb582910.svg";
export { ForwardRef as ReactComponent };